/* eslint-disable no-magic-numbers */
import { graphql } from "msw";
import { getUnsecuredJWT } from "Apimocks/utils/getUnsecuredJWT";
import { getGroups } from "../groups/groups.handler";

let user;

const getUser = async () => {
    if (user) return user;
    const groups = await getGroups();
    // eslint-disable-next-line require-atomic-updates
    user = {
        _id: "1",
        email: "test@email.com",
        firstname: "John",
        groups: groups.slice(0,5).map(g => ({ __typename: "ProjectGroup", ...g })),
        lastname: "Smith"
    };
    return user;
};

let currentToken;
let expiresAt;
let refreshExpiresAt;

const generateNewJWT = async (req, res, ctx, key) => {
    const secret = Date.now();

    const UnsecuredJWT = await getUnsecuredJWT(); 
    const unsecuredJwt = new UnsecuredJWT({ ...await getUser(), secret })
        .setIssuedAt()
        .setIssuer("v3mockbackend")
        .setAudience("v3storybook")
        .setExpirationTime("5m")
        .setSubject(user.id)
        .setNotBefore(0)
        .encode();

    const unsecuredRefreshJWT = new UnsecuredJWT({ secret })
        .setIssuedAt()
        .setIssuer("v3mockbackend")
        .setAudience("v3storybook")
        .setExpirationTime("30m")
        .setSubject(user.id)
        .setNotBefore(0)
        .encode();

    currentToken = secret;
    expiresAt = Date.now() + 1000 * 60 * 5;
    refreshExpiresAt = Date.now() + 1000 * 60 * 30;

    return res(
        ctx.delay(),
        ctx.data({ [key]: {
            access_token: unsecuredJwt,
            expires_in: expiresAt,
            refresh_expires_in: refreshExpiresAt,
            refresh_token: unsecuredRefreshJWT
        } })
    );
};

const returnError = (req, res, ctx, error, code) => {
    return res(
        ctx.delay(),
        ctx.status(code),
        ctx.data({ error })
    );
};

export const handlers = [
    graphql.mutation("loginUser", async (req, res, ctx) => {
        const { username, password } = req.variables;

        if (
            username !== "test@masterdocs.com.au" ||
            password !== "password123!"
        )
            return returnError(req, res, ctx, "incorrect username or password", 403);
        return generateNewJWT(req, res, ctx, "loginUser");
    }),
    graphql.mutation("refreshUserSession", async (req, res, ctx) => {
        const hasExpired = refreshExpiresAt < Date.now();
        if (!hasExpired) {
            return generateNewJWT(req, res, ctx, "refreshUserSession");
        }
        return returnError(req, res, ctx, "Refesh token expired", 401);
    }),
    graphql.mutation("logoutUser", async (req, res, ctx) => {
        const { authorization } = req.headers.map;
        const UnsecuredJWT = await getUnsecuredJWT();

        if (authorization) {
            const jwt = authorization.split("Bearer ").pop();
            const { payload } = UnsecuredJWT.decode(jwt, {
                issuer: "v3mockbackend",
                audience: "v3storybook",
            });
            if (payload.secret === currentToken) {
                currentToken = null;
                expiresAt = null;
                refreshExpiresAt = null;
            }
            return res(
                ctx.delay(),
                ctx.data({ logoutUser: "done" })
            ); 
        }
        return returnError(req, res, ctx, "no token to logout", 401);
    }),
    graphql.mutation("triggerPasswordReset", (req, res, ctx) => {
        return res(
            ctx.delay(),
            ctx.data({ triggerPasswordReset: "done" })
        );
    }),
    graphql.mutation("changePassword", (req, res, ctx) => {
        const { newPassword, confirmation } = req.variables;
        const responseData =
            newPassword === confirmation
                ? { password: newPassword }
                : {
                    error:
                          "Passwords do not match. Please ensure that confirmation matches new password",
                };
        return res(
            ctx.delay(),
            ctx.data({ changePassword: responseData })
        );
    }),
    graphql.query("me", async (req, res, ctx) => {
        const { authorization } = req.headers.map;
        const UnsecuredJWT = await getUnsecuredJWT();

        // If there's an auth header present, we're looking at auth stories, otherwise just return the user
        if (authorization) {
            const jwt = authorization.split("Bearer ").pop();
            const { payload } = UnsecuredJWT.decode(jwt, {
                issuer: "v3mockbackend",
                audience: "v3storybook",
            });
            if (payload.secret === currentToken) {
                return res(ctx.data({ me: await getUser() }));
            }
        } else {
            return res(ctx.data({ me: await getUser() }));
        }
        return returnError(req, res, ctx, "invalid token", 401);
    }),
    graphql.mutation("startLogin", (req, res, ctx) => {
        const { redirect_uri } = req.variables;
        return res(
            ctx.delay(),
            ctx.data({ startLogin: `https://mock.identity.app.masterdocs.com.au?redirect=${redirect_uri}&code=foo` })
        );
    }),
    graphql.mutation("redeeemCode", (req, res, ctx) => {
        return generateNewJWT(req, res, ctx, "redeemCode");
    })
];
